import { CardsDataSourceBase } from "../../common/CardsDataSourceBase";
import { injectable } from "inversify";
import { injectToken } from "inversify-token";
import { YinzCamAPIResponse } from "yinzcam-api";
import { YinzCamAppServerToken } from "yinzcam-appserver";

@injectable()
export class YinzCamAppServerHasData extends CardsDataSourceBase {
  public constructor(@injectToken(YinzCamAppServerToken) server) {
    super({ server })
  }

  protected processResponse(response: YinzCamAPIResponse): object | any[] {
    const data = response?.data as any;
    console.log ('YinzCamAppServerHasData: ', data);
    if(data?.Scores){
    	return [].concat(data?.Scores?.Day?.Game);	
    } else if(data?.Media) {
    	return [].concat(data?.Media?.MediaSection).reduce((acc, cur) => acc.concat([].concat(cur?.Item)), []);
    } else {
    	return [];
    }
  }
}
